<template>
  <div class="language-switcher">
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      :class="{ active: currentLocale === 'bg' }"
      @click="switchLanguage('bg')"
    >
      BG
    </button>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      :class="{ active: currentLocale === 'en' }"
      @click="switchLanguage('en')"
    >
      EN
    </button>
  </div>
</template>

<script>
  export default {
    name: "LanguageSwitcher",
    computed: {
      currentLocale() {
        return this.$i18n.locale;
      },
    },
    methods: {
      switchLanguage(locale) {
        if (this.currentLocale === locale) {
          return; // Already on this locale
        }

        // Update i18n locale
        this.$i18n.locale = locale;

        // Save to localStorage
        localStorage.setItem("locale", locale);

        // Navigate to the same route with new locale
        const currentRoute = this.$route;
        this.$router.push({
          name: currentRoute.name,
          params: { ...currentRoute.params, locale: locale },
          query: currentRoute.query,
        });
      },
    },
  };
</script>

<style scoped>
  .language-switcher {
    display: inline-flex;
    gap: 0.25rem;
  }

  .language-switcher .btn {
    min-width: 40px;
    font-weight: 600;
    transition: all 0.2s ease;
  }

  .language-switcher .btn.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
  }

  .language-switcher .btn:not(.active):hover {
    background-color: #f8f9fa;
  }
</style>
